import UserComponent from '../UserComponent.vue'

export default [
    {
        path: '/users',
        name: 'Users',
        meta: { 
            layout: 'default',
            requiresRole: [1] // Only super admin (role_id = 1) can access
        },
        component: UserComponent,
    },
]